import { createClient } from '@formium/client';

export const formium = createClient('60255d744da96d0001a0cbc0', {
  apiToken: 'soWH8F6PMxyZUSavgoiC85nv62582AGgmecAz2WCFIFvYDoI5jcv42UVNDT0eeSy',
});
